'use client';

import { usePathname } from 'next/navigation';

import { Locales, WistiaMediaData } from '@monoimin/sb-types';

import { adjustPathname, getUrlOrigin } from '@monoimin/utils/helpers';
import { VideoSchema } from '@monoimin/schemas';

import { getPathnameWithoutPrefix } from '@monoimin/intl';

import {
  dateFormatter,
  formatVideoDuration,
  getWistiaPublicAsset,
  getWistiaThumbnailUrl,
} from './utils';

export const WistiaVideoSchema = ({
  data,
  locale,
}: {
  data: WistiaMediaData;
  locale: Locales;
}) => {
  const videoId = data.hashedId;

  const publicAsset = getWistiaPublicAsset(data);

  const timestamp = data.createdAt * 1000 || publicAsset?.created_at;

  const origin = getUrlOrigin(locale);

  const pathname = usePathname();

  const pathnameWithoutPrefix = getPathnameWithoutPrefix(pathname, locale);

  const url = adjustPathname(`${origin}${pathnameWithoutPrefix}`);

  return (
    <VideoSchema
      id={videoId}
      name={data.name}
      description={data.seoDescription}
      duration={formatVideoDuration(data.duration)}
      uploadDate={typeof timestamp === 'number' ? dateFormatter(timestamp) : ''}
      thumbnailUrl={getWistiaThumbnailUrl(data)}
      contentUrl={`https://imin.wistia.com/medias/${videoId}`}
      embedUrl={`https://fast.wistia.com/embed/medias/${videoId}`}
      potentialAction={{
        '@type': 'SeekToAction',
        target: `${url}#?wid=${videoId}&wtime={seek_to_second_number}`,
        'startOffset-input': 'required name=seek_to_second_number',
      }}
    />
  );
};
